export default __webpack_public_path__ + "static/media/programmingHeroLogo.19478904.png";